import type { Brand } from '@seek/melways-sites';
import { useTranslations } from '@vocab/react';
import { Alert, Stack, Text, Inline } from 'braid-design-system';

import { PageTitles } from 'src/components/Notifications/pageTitle';

import translations from './.vocab';

const AccountDeleteBanner = ({ brand }: { brand: Brand }) => {
  const { t } = useTranslations(translations);

  return (
    <Stack space="xlarge">
      <Alert tone="info">
        <Inline space="medium">
          <Text weight="strong" size="standard">
            {t('Do you have other BRAND accounts?', {
              brand: PageTitles[brand],
            })}
          </Text>
          <Text>
            {t(
              'This deletes your BRAND profile and job search account only. Other SEEK accounts like SEEK Pass stay active.',
              { brand: PageTitles[brand] },
            )}
          </Text>
        </Inline>
      </Alert>
    </Stack>
  );
};

export default AccountDeleteBanner;
